export default [
  {
    path: '/cor/',
    name: 'cor',
    component: () => import('../views/CorView.vue'),
    redirect: { name: 'cor-listar' },
    children: [
      {
        path: 'welcome',
        name: 'cor-listar',
        meta: {
          title: 'Cor',
        },
        component: () => import('../views/CorWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'cor-cadastrar',
        meta: {
          title: 'Cor cadastrar',
        },
        component: () => import('../views/CorFormView.vue'),
      },
      {
        path: ':id',
        name: 'cor-editar',
        meta: {
          title: 'Cor editar',
        },
        component: () => import('../views/CorFormView.vue'),
      },
    ],
  },
];
